module.exports = __webpack_public_path__ + "img/imagezoomed.05221f81.png";